import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-items" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-email" }
const _hoisted_4 = {
  key: 1,
  class: "mobile-menu"
}
const _hoisted_5 = { class: "user-email" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentAdd = _resolveComponent("DocumentAdd")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_List = _resolveComponent("List")!
  const _component_User = _resolveComponent("User")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "app-container" }, {
    default: _withCtx(() => [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_el_header, { key: 0 }, {
            default: _withCtx(() => [
              (!_ctx.isMobile)
                ? (_openBlock(), _createBlock(_component_el_menu, {
                    key: 0,
                    mode: "horizontal",
                    router: "",
                    class: "desktop-menu"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_el_menu_item, {
                          index: "/",
                          onClick: _ctx.resetOrderStep
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_DocumentAdd)
                              ]),
                              _: 1
                            }),
                            _cache[2] || (_cache[2] = _createTextVNode(" Новый заказ "))
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_menu_item, { index: "/orders" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_List)
                              ]),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Мои заказы "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "/senders" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_User)
                              ]),
                              _: 1
                            }),
                            _cache[4] || (_cache[4] = _createTextVNode(" Договоры с МНОС "))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.user?.email), 1),
                        _createVNode(_component_el_button, {
                          link: "",
                          onClick: _ctx.handleLogout
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Выйти из аккаунта")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_el_row, {
                      align: "middle",
                      justify: "space-between"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 4 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown, { trigger: "click" }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, { onClick: _ctx.resetOrderStep }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DocumentAdd)
                                          ]),
                                          _: 1
                                        }),
                                        _cache[6] || (_cache[6] = _createTextVNode(" Новый заказ "))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/orders')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_List)
                                          ]),
                                          _: 1
                                        }),
                                        _cache[7] || (_cache[7] = _createTextVNode(" Мои заказы "))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/senders')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_User)
                                          ]),
                                          _: 1
                                        }),
                                        _cache[8] || (_cache[8] = _createTextVNode(" Отправители "))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_dropdown_item, {
                                      divided: "",
                                      onClick: _ctx.handleLogout
                                    }, {
                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createTextVNode(" Выйти из аккаунта ")
                                      ])),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Menu)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 20,
                          class: "mobile-user-info"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user?.email), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}